import React from "react";

const iconLink =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-[#064E8D] hover:bg-gray-100 transition-colors no-underline";
const iconMuted =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors";
const iconDanger =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-red-600 hover:bg-red-50 transition-colors";

/**
 * Row actions for freight new-user queue (DataTable cell).
 * Uses anchors + `getNavigate` because cells mount via `createRoot` (no Router context for `<Link>`).
 */
const FreightNewUserDtActions = ({ row, onVerify, onDeactivate, getNavigate }) => {
  if (row?.id == null) return null;
  const id = row.id;

  const go = (path) => {
    const nav = getNavigate?.();
    if (typeof nav === "function") {
      nav(path);
      return;
    }
    window.location.assign(path);
  };

  return (
    <div className="flex items-center justify-center gap-0.5 flex-wrap">
      <a
        href={`/freight/new_users/${id}/edit`}
        className={iconLink}
        title="Edit user"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/new_users/${id}/edit`);
        }}
      >
        <i className="fas fa-pen text-sm" aria-hidden />
      </a>
      <a
        href={`/freight/new_users/${id}/rm`}
        className={iconLink}
        title="RM"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/new_users/${id}/rm`);
        }}
      >
        <i className="fas fa-map-marked-alt text-sm" aria-hidden />
      </a>
      <button type="button" className={iconMuted} title="Verify approve" onClick={() => onVerify?.(id, "1")}>
        <i className="fas fa-check text-sm" aria-hidden />
      </button>
      <button type="button" className={iconDanger} title="Verify reject" onClick={() => onVerify?.(id, "2")}>
        <i className="fas fa-times text-sm" aria-hidden />
      </button>
      <button type="button" className={iconDanger} title="Toggle status" onClick={() => onDeactivate?.(id)}>
        <i className="fas fa-toggle-on text-sm" aria-hidden />
      </button>
    </div>
  );
};

export default FreightNewUserDtActions;
